import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas";
import rootReducer from "./reducers";

export const setupStore = (preloadedState = null) => {
  const sagaMiddleware = createSagaMiddleware();

  const config = {
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }) // don't be alarmed, these are always disabled in prod. Disabling in dev because there's a HUGE slowdown when you have large amounts of data in the store.
        .prepend(sagaMiddleware),
    ],
    devTools: process.env.NODE_ENV !== "production",
  };

  if (preloadedState) {
    // mainly used for testing
    config.preloadedState = preloadedState;
  }

  const preparedStore = configureStore(config);

  sagaMiddleware.run(rootSaga);

  return preparedStore;
};

const store = setupStore();

export default store;
